import React, { useEffect } from 'react';
import { View, Text, Image, TouchableOpacity, ImageBackground, Platform } from 'react-native';
import styles from './styles/welcomeWebStyles'; 
import { useLogScreen } from '../useLogScreen';
export default function WelcomeWeb({ navigation }) {
    useLogScreen('Welcome');
    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Bem-vindo';
            }, 100);
        }
    }, []);

    return (
        <ImageBackground
            source={require('../assets/img/bg.png')}
            style={styles.background}
            resizeMode="cover"
        >
            <View style={styles.card}>
                <Image
                    source={require('../assets/img/logo.png')}
                    style={styles.logo}
                    resizeMode="contain"
                />
                <Text style={styles.title}>Faça parte da imoGo</Text>

                <TouchableOpacity
                    style={styles.primaryButton}
                    onPress={() => navigation.navigate('RegisterWeb')}
                >
                    <Text style={styles.primaryButtonText}>Criar cadastro</Text>
                </TouchableOpacity>

                <TouchableOpacity
                    style={styles.secondaryButton}
                    onPress={() => navigation.navigate('LoginWeb')}
                >
                    <Text style={styles.secondaryButtonText}>Já tenho acesso</Text>
                </TouchableOpacity>
            </View>
        </ImageBackground>
    );
}
